import { Badge, Box, HStack, Text } from "@chakra-ui/react";

export interface ReportTextBlock {
  label?: string | null;
  value?: string | null;
  badge?: string | null;
}

export const FieldBlock = ({ block }: { block: ReportTextBlock }) => (
  <HStack align="baseline" spacing="3">
    <Text fontSize="sm" color="smMuted" minW="220px">
      {block.label}
    </Text>
    <Text fontSize="sm" color="smText" whiteSpace="pre-wrap">
      {block.value || "–"}
    </Text>
  </HStack>
);

export const ParagraphBlock = ({ block }: { block: ReportTextBlock }) => (
  <Box py="1">
    {block.label && (
      <Text
        fontSize="xs"
        color="smMuted"
        textTransform="uppercase"
        letterSpacing="0.03em"
        mb="1"
      >
        {block.label}
      </Text>
    )}
    <Text fontSize="sm" color="smText" whiteSpace="pre-wrap">
      {block.value}
    </Text>
  </Box>
);

export const NoteBlock = ({ block }: { block: ReportTextBlock }) => (
  <Box py="1">
    {block.label && (
      <Text fontSize="sm" color="smMuted" mb="1">
        {block.label}
      </Text>
    )}
    <Text
      fontSize="sm"
      fontStyle="italic"
      color="smMuted"
      whiteSpace="pre-wrap"
    >
      {block.value}
    </Text>
  </Box>
);

export const SubheadingBlock = ({ block }: { block: ReportTextBlock }) => (
  <HStack align="baseline" spacing="2" pt="2" pb="1">
    <Text fontSize="md" fontWeight="700" color="smPrimary">
      {block.value}
    </Text>
    {block.badge && (
      <Badge
        colorScheme="teal"
        variant="subtle"
        rounded="full"
        px="2"
        textTransform="none"
        fontWeight="600"
      >
        {block.badge}
      </Badge>
    )}
    {block.label && (
      <Text fontSize="sm" color="smMuted">
        {block.label}
      </Text>
    )}
  </HStack>
);
